/**
 * 报表组件-异步导出
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/01/30      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 * @param onChange   值改变回调事件
 * @param styleName  带入样式
 * @param api        默认空，使用新打印导出接口
 * @param canClick   是否直接点击，默认true，如果有点击导出前置条件配置false，另外配置 clickHandle
 * @param text       按钮显示内容
 * */
import React from "react";
import {isEmpty } from '@utils/utils';
import PropTypes from "prop-types";
import { message,Tooltip,Spin} from "antd";
import Lang from "@components/Lang/Lang"
import ExportAsyncBtnService from "./ExportAsyncBtn.action";
export default class ExportAsyncBtn extends React.Component {
    static propTypes = {
        styleName: PropTypes.string, // 样式名
        api: PropTypes.string, // 默认空，使用新打印导出接口
        postParam: PropTypes.any, // 参数
        canClick: PropTypes.bool, // 是否直接点击
        clickHandle: PropTypes.any,  // 无时显示 导出
        text: PropTypes.any,
    };
    static defaultProps = {
        styleName:"",
        api:"",
        postParam:{},
        canClick:true, // 回调其他行为成功才改变值，如购物车加购成功才改变值，可设置为false,
    }
    constructor(props) {
        super(props);
        this.state = {
            valueState: "",
        };
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 点击导出
     * */
    onClickExport() {
      const {canClick,postParam } = this.props;
      if(canClick){
          this.goExport(postParam)
      }else if(this.props.clickHandle)this.props.clickHandle()
    }
    /*
     * 导出
     * */
    goExport(postParam) {
        this.loading(true);
        // 新打印导出接口
        const {api,} = this.props;
        ExportAsyncBtnService.fetch(api||"/service/fenxiao/pub/report/do-export",postParam).then((resp={})=>this.handleRes(resp.data,postParam)).catch(err=>this.handleErr(err,postParam));
    }
    handleRes(resp={},postParam){
        // 响应结果
        const { success, valid,model } = resp;
        if (success && valid&&model&&model.successCount==1) {
            // 成功 响应结果
            this.loading(false);
            if(model.fileUrl){
                window.open(model.fileUrl);
            }
        }else {
            if((model&&model.successCount==-1)||(!valid||!success)){
                //导出失败
                if(resp.resultCode){
                    message.warning(Lang({id: resp.resultCode, }));
                }else if(resp.message){
                    message.warning(resp.message);
                }else {
                    message.warning(Lang({id: 'DaoChuShiBai', default: '导出失败'}));
                }
                if(this.showTimer){
                    clearTimeout(this.showTimer);
                }
                this.loading(false);
                return false;
            }else {
                this.showTimer =  setTimeout(()=>{
                    this.goExport(postParam);
                },2000)
            }
        }
    }
    componentDidMount() {
        if(this.props.onRef)  this.props.onRef(this);
    };
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {tooltips, styleName, text} = this.props;
        const {loading = false,} = this.state;
        return (<Spin spinning={loading}>{tooltips ? <Tooltip title={<span className={"font_12"}>{tooltips}</span>}>
            <span className={styleName || "ant-btn ant-btn-default cursor-p"} onClick={() => this.onClickExport()}
                  loading={loading}>
                {text || Lang({id: 'DaoChu', default: '导出'})}
            </span>
            </Tooltip> :
            <span className={styleName || "ant-btn ant-btn-default cursor-p"} onClick={() => this.onClickExport()}
                  loading={loading}>
                {text || Lang({id: 'DaoChu', default: '导出'})}
            </span>}
        </Spin>);
    }
}